/**
 * Build a URL for color facet verification: this color + in stock (availability=1)
 * only — no other facet params from data-verify-url. Collection pages need only
 * pathname; search must keep q and options[prefix] so the section returns results.
 */
function buildColorFacetVerifyPath(row) {
  var verifyPath = row.getAttribute('data-verify-url');
  var param = row.getAttribute('data-param');
  var val = row.getAttribute('data-value');
  if (!verifyPath || !param || val == null) return null;
  var base = new URL(verifyPath, window.location.origin);
  var u = new URL(base.pathname, window.location.origin);
  var path = base.pathname;
  if (path === '/search' || path.endsWith('/search')) {
    var q = base.searchParams.get('q');
    if (q != null && q !== '') u.searchParams.set('q', q);
    var optPrefix = base.searchParams.get('options[prefix]');
    if (optPrefix != null) u.searchParams.set('options[prefix]', optPrefix);
  }
  u.searchParams.set('filter.v.availability', '1');
  u.searchParams.set(param, val);
  return u.pathname + u.search;
}

function parseSectionProductGridCount(html) {
  var doc = new DOMParser().parseFromString(html, 'text/html');
  if (doc.querySelector('#product-grid.collection--empty')) {
    return 0;
  }
  var ul = doc.querySelector('ul#product-grid');
  if (ul) {
    return ul.querySelectorAll('li.grid__item').length;
  }
  return null;
}

/**
 * Remove Color facet rows where the filtered collection or search (availability +
 * that color) renders no product cards — i.e. no available variants for that color.
 */
function verifyColorFilterFacetAvailability() {
  var grid = document.getElementById('product-grid');
  if (!grid) return;
  var sectionId = grid.getAttribute('data-id');
  if (!sectionId) return;

  var rows = document.querySelectorAll('.collection-filters-tab--color .collection-filters-tab-content-value[data-verify-url]');
  if (rows.length === 0) return;

  var urlToElements = new Map();
  for (var i = 0; i < rows.length; i++) {
    var normalized = buildColorFacetVerifyPath(rows[i]);
    if (!normalized) continue;
    if (!urlToElements.has(normalized)) urlToElements.set(normalized, []);
    urlToElements.get(normalized).push(rows[i]);
  }

  var urls = Array.from(urlToElements.keys());
  var fetchOne = function(verifyPath) {
    var url = new URL(verifyPath, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function(r) {
        return r.text();
      })
      .then(function(html) {
        return { verifyPath: verifyPath, count: parseSectionProductGridCount(html) };
      })
      .catch(function() {
        return { verifyPath: verifyPath, count: null };
      });
  };

  Promise.all(urls.map(fetchOne)).then(function(results) {
    results.forEach(function(res) {
      if (res.count === null) return;
      var els = urlToElements.get(res.verifyPath);
      if (!els) return;
      if (res.count === 0) {
        els.forEach(function(el) {
          el.remove();
        });
      }
    });

    document.querySelectorAll('.collection-filters-tab--color').forEach(function(tab) {
      var content = tab.querySelector('.collection-filters-tab-content');
      if (!content || content.querySelectorAll('.collection-filters-tab-content-value').length > 0) return;
      var desktopFilter = tab.closest('.collection-filters-filter.show-desktop');
      if (desktopFilter) {
        desktopFilter.style.display = 'none';
      } else {
        tab.style.display = 'none';
      }
    });
  });
}

window.verifyColorFilterFacetAvailability = verifyColorFilterFacetAvailability;

function colorFilterHasAvailableVariants() {
  var colorTabs = document.querySelectorAll('.collection-filters-tab--color .collection-filters-tab-content');
  for (var i = 0; i < colorTabs.length; i++) {
    if (colorTabs[i].querySelectorAll('.collection-filters-tab-content-value').length > 0) {
      return true;
    }
  }
  return document.querySelectorAll('.collection-filters-tab-content-value-color').length > 0;
}

window.colorFilterHasAvailableVariants = colorFilterHasAvailableVariants;

$(document).ready(function() {
  
  $('.collection-filters-filter-all a').on('click', function() {
    var link = $(this);
    var bar = $('.collection-filters-bar-all');
    if (link.hasClass('active')) {
	  link.removeClass('active');
      bar.slideUp(250);
    } else {
      link.addClass('active');
      bar.slideDown(250);
    }
    return false;
  });
  $('.collection-filters-filter:not(.collection-filters-filter-all) a').on('click', function() {
    var link = $(this);
    var bar = $('.collection-filters-bar', link.closest('.collection-filters-filter'));
    if (link.hasClass('active')) {
	  link.removeClass('active');
      bar.slideUp(250);
    } else {
      $('.collection-filters-filter a.active').removeClass('active');
      $('.collection-filters-bar').hide();
      link.addClass('active');
      bar.slideDown(250);
    }
    return false;
  });
  $('.collection-filters-bar.collection-filters-bar-all .collection-filters-tab .collection-filters-label').on('click', function() {
    var link = $(this);
    var bar = $('.collection-filters-tab-content', link.closest('.collection-filters-tab'));
    if (link.hasClass('active')) {
	  link.removeClass('active');
      bar.slideUp(250);
    } else {
      link.addClass('active');
      bar.slideDown(250);
    }
    return false;
  });
  $('.collection-sort a').on('click', function() {
    var link = $(this);
    var bar = $('.collection-sort-bar');
    if (link.hasClass('active')) {
      link.removeClass('active');
      bar.slideUp(250);
    } else {
      link.addClass('active');
      bar.slideDown(250);
    }
    return false;
  });

  $('.collection-sort-bar a').on('click', function(e) {
    e.preventDefault()
    var scrollY = `&scroll.y=${window.scrollY}`;
    window.location.href = `${e.target.href}${scrollY}`;
  });

  $('.collection-line .collection-filters-bar .collection-filters-tab .collection-filters-tab-heading').on('click', function() {
    var tab = $(this).closest('.collection-filters-tab');
    tab.toggleClass('open');
    $('.collection-filters-tab-content', tab).slideToggle('normal');
  });
  $('.collection-line .collection-filters-bar .collection-filters-tab .collection-filters-tab-content .collection-filters-tab-content-value').on('click', function() {
    var checkbox = $('.checkbox', $(this));
    checkbox.toggleClass('checked');
  });
  $('.collection-filters-bar .apply-filters').on('click', function(e) {
    let $form = $(e.currentTarget).closest('.rs-collection-filters');
    var sort_by = '';
    if (window.location.href.indexOf('sort_by=') != -1) {
      var match = window.location.href.match(/sort_by=([^&]+)/);
      if (match != null) {
      	sort_by = match[1];
      }
    }
    var uri = collection_uri + '?sort_by=' + sort_by + '&filter.v.price.gte=' + $form.find('.filter-min-price').val() + '&filter.v.price.lte=' + $form.find('.filter-max-price').val();
    if (typeof hide_sold_out !== 'undefined' && hide_sold_out) {
      uri += '&filter.v.availability=1';
    }
    var checked = $form.find('.checkbox.checked');
    $.each(checked, function(k, v) {
      var filter = $(v).closest('.collection-filters-tab-content-value');
      uri += '&' + filter.data('param') + '=' + filter.data('value');
    });
    window.location.href = uri;
    var event = new CustomEvent("anchor:offset");
    document.dispatchEvent(event);
    return false;
  });
  
  if ($('#price-range').length > 0) {
    $('#price-range').slider({
      range: true,
      min: $('#price-range').data('min'),
      max: $('#price-range').data('max'),
      values: [$('#price-range').data('current-min'), $('#price-range').data('current-max')],
      slide: function(event, ui) {
        $('.collection-filters-prices .collection-filters-prices-input:first-child input').val(ui.values[0]);
        $('.collection-filters-prices .collection-filters-prices-input:last-child input').val(ui.values[1]);
      }
    });
    $('.collection-filters-prices .collection-filters-prices-input:first-child input').val($('#price-range').slider('values', 0));
    $('.collection-filters-prices .collection-filters-prices-input:last-child input').val($('#price-range').slider('values', 1));
  }

  verifyColorFilterFacetAvailability();
});

function buildUrlParams(searchParams, variable, value) {
  if(value && value != '0') {
    searchParams.set(variable, value);
  }
  return searchParams;
}